import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { LabelSetting } from "../../../i18n/locale-helper"
import moduleConstant from "../../../common/module-constant";
import { HISTORY_MODES, ROUTER } from "../../../common/constants";
import { ROUTER_HELPER } from "../../../common/router-helper.contstants";
import { namespace, Mutation, Getter } from "vuex-class";
import { storeModules } from "../../../store";
import { IDrawerModel, DrawerModel } from "../../../models/common/drawer.model";
import { DRAWER_NAME } from "../../../common/drawer-component.constants";
import { IAuthConfigModel } from "../../../models/user/auth-config.model";

const CommonMutation = namespace(storeModules.Common, Mutation);
const UserGetter = namespace(storeModules.User, Getter);
@Component({
    template: require("./template.html"),
    components: {
        'email-out': () => import("../../../containers/history/email-out/EmailOutComponent.vue")
    }
})
class TimeLineComponent extends Vue {
	@Prop()
	data: any[];

	@Prop()
	isLoading: boolean;

	@Prop({ default: null })
	scrollbarOffset: number;

	@Prop({ default: false })
	isAgenda: boolean;

	@Prop({ default: true })
	hasScrollbar: boolean;

	@Prop({ default: null })
	fixHeight: number;

	@Prop({ default: 0, type: Number }) moduleType: number;

    @Prop({ default: false, type: [Boolean] }) viewHistory;
    
    @CommonMutation setVisibleDrawerModel: (payload: IDrawerModel) => void;

    @UserGetter authConfig: IAuthConfigModel;

	// historyModalVisible: boolean = false;
	historyModalModuleType: number = null;
    historyModalId: number = null;
    
    historyData: any = null;
    visibleEmailOut: boolean = false;
    selectedEmailOut = null;

	get coModuleType() {
		return this.moduleType;
	}

	get lblGlobal() {
		return LabelSetting.Global;
	}

	get lblProperty() {
		return LabelSetting.Property;
    }
    
    get IsAllowDeleteHistory() {
        return this.authConfig && this.authConfig.Config && this.authConfig.Config.IsAllowDeleteHistory;
    }

    isShowEmailOut(item) {
        if (item.TypeId === 4) return true;
        return false;
    }

    openEmailOut(item) {
        this.visibleEmailOut = true;
        this.selectedEmailOut = item;
    }

    deleteHistory(record) {
        this.$emit('delete', record);
    }
	
	getDate(date: string) {
		if (!date) return "";

		const d = new Date(date);
        const lang = localStorage.getItem("lang") as any;
        
        if (!lang) return "";
        const formatedDate = Intl.DateTimeFormat(lang, {
			weekday: "long",
			month: "short",
			day: "numeric",
			year: "numeric"
		}).format(d);
		return formatedDate;
	}

	getTime(date: string) {
		if (!date) return "";
        const lang = localStorage.getItem("lang") as any;
        if (!lang) return "";
        return this.$formatDateTimeByLocale(date);
	}

	getHtmlText(str) {
		return str.replace(/\n/g, "<br />").replace(/\u21b5/g, "<br />");
	}
	private buildHistoryModalParams(data) {
		this.historyModalModuleType = this.coModuleType;
		this.historyModalId = data.RootId;
	}
	openHistory(item) {
		console.log('open history: ', item);
		switch(item.Type) {
			case HISTORY_MODES.HISTORY:
                this.buildHistoryModalParams(item);
                this.setVisibleDrawerModel(new DrawerModel({
                    componentName: DRAWER_NAME.HISTORY_MODAL,
                    props: {
                        id: this.historyModalId,
                        type: 1,
                        showViewPerson: true,
                        moduleType: this.historyModalModuleType,
                    },
                    title: 'HISTORYDETAIL',
                    showSaveBtn: true
                }))
				// this.historyModalVisible = true;
				break;
			case HISTORY_MODES.AGENDA:
				const routeName = item.AppointmentIsRecurrence && !item.AppointmentIsException ?
					ROUTER.AGENDA.AGENDA_EDIT_SERIES
					: ROUTER.AGENDA.AGENDA_EDIT
				this.$router.push({
					name: routeName,
					params: {
						id: item.RootId.toString()
					}
				})
				break;
			case HISTORY_MODES.TASK:
				this.$router.push({
					name: ROUTER.TASK.TASK_EDIT,
					params: {
						id: item.RootId.toString()
					}
				})
				break;
			default:
				break;
		}
	}

	public getTypeHistory() {
		switch (this.coModuleType) {
			case moduleConstant.Object:
			case moduleConstant.Project:
				return { type: ROUTER_HELPER.TYPE.PROPERTY, action: ROUTER_HELPER.ACTION.VIEW };
			case moduleConstant.Demand:
				return { type: ROUTER_HELPER.TYPE.DEMAND, action: ROUTER_HELPER.ACTION.VIEW };
			case moduleConstant.Person:
				return { type: ROUTER_HELPER.TYPE.CLIENT, action: ROUTER_HELPER.ACTION.VIEW };
			default:
				return { type: ROUTER_HELPER.TYPE.HISTORY, action: ROUTER_HELPER.ACTION.VIEW };
		}
    }
    
    handleOpenPersonDetail(record) {
        let param = {
            componentName: DRAWER_NAME.PERSON_DETAIL,
            props: {
                objectId: record.Id,
            },
            title: 'PERSON'
        }
        switch (this.coModuleType) {
            case moduleConstant.Object:
                param.componentName = DRAWER_NAME.PERSON_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PERSON'
                break;
            case moduleConstant.Project:
                param.componentName = DRAWER_NAME.PERSON_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PERSON'
                break
            case moduleConstant.Demand:
                param.componentName = DRAWER_NAME.PERSON_DETAIL;
                param.props.objectId = record.Id
                param.title = 'PERSON'
                break
            case moduleConstant.Person:
                param.componentName = DRAWER_NAME.PERSON_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PERSON'
                break
            default:
                break;
        }

            this.setVisibleDrawerModel(new DrawerModel(param))
    }

    handleOpenPropertyDetail(record) {
        let param = {
            componentName: DRAWER_NAME.PROPERTY_DETAIL,
            props: {
                objectId: record.Id,
            },
            title: 'PROPERTY'
        }
        switch (this.coModuleType) {
            case moduleConstant.Object:
                param.componentName = DRAWER_NAME.PROPERTY_DETAIL;
                param.props.objectId = record.Id
                param.title = 'PROPERTY'
                break;
            case moduleConstant.Project:
                param.componentName = DRAWER_NAME.PROPERTY_DETAIL;
                param.props.objectId = record.Id
                param.title = 'PROPERTY'
                break
            case moduleConstant.Demand:
                param.componentName = DRAWER_NAME.PROPERTY_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PROPERTY'
                break
            case moduleConstant.Person:
                param.componentName = DRAWER_NAME.PROPERTY_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PROPERTY'
                break
            default:
                break;
        }
        this.setVisibleDrawerModel(new DrawerModel(param));
    }

	get isViewHistory() {
		return true;
    }

    openHistoryByAppLink() {
        const {type, historyId} = this.$route.params;
        const item = {
            id: parseInt(historyId),
        }

        this.setVisibleDrawerModel(new DrawerModel({
            componentName: DRAWER_NAME.HISTORY_MODAL,
            props: {
                id: item.id,
                type: 1,
                showViewPerson: true,
                moduleType: parseInt(type),
            },
            title: 'HISTORYDETAIL',
            showSaveBtn: true
        }))
    }

    mounted() {
        const {personId, propertyId, projectId} = this.$route.params;
        if (personId || propertyId || projectId) {
            this.openHistoryByAppLink()
        }
    }
}

export default TimeLineComponent;
